import React from 'react';
import PropTypes from 'prop-types';

import { Redirect, Switch } from 'react-router-dom';
import Route from './router/Route';

import { withAppContext } from './contexts/app';

import Home from './views/Home';
import SnapPhoto from './views/SnapPhoto';
import Patient from './views/Patient';
import Results from './views/Results';
import CreateAccount from './views/CreateAccount';
import TermsOfService from './views/TermsOfService';
import About from './views/About';
import Health from './views/Health';
import ClinicalSolutions from './views/ClinicalSolutions';
import Error from './views/Error';
import BodyLocator from './views/BodyLocator';
import QA from './views/QA';
import Condition from './views/Condition';
import ResetPassword from './views/ResetPassword';
import Profile from './views/Profile';

// Routes and supporting data for development purposes
/* import { Results } from './views/Results'; */
/* import clinicalDataDev from './clinicalData-dev.json'; */
/* import KitchenSink from './views/KitchenSink'; */

class AppRouter extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isOfflineMode } = this.props.app;

    return (
      <Switch>
        <Route availableOffline exact path="/" component={() => {
          this.props.app.reset(false);

          return (isOfflineMode) ? <Redirect to="/clinical" /> : <Home />;
        }} />

        {/* <Route exact path="/bodylocator" component={BodyLocator} /> */}
        {/* <Route exact path="/kitchensink" component={KitchenSink} /> */}

        {/* <Route path="/results-dev" component={() => <ConditionResults clinicalData={clinicalDataDev} />} /> */}

        <Route exact path="/health" component={Health} />
        <Route path="/health/conditions/:id" component={Condition} />
        <Route exact path="/reset-password/:token" component={ResetPassword} />
        <Route exact path="/terms" component={TermsOfService} />
        <Route exact path="/about" component={About} />
        <Route availableOffline exact path="/clinical" component={ClinicalSolutions} />
        <Route exact path="/clinical-app" component={() => <Redirect to="/clinical" />} />

        <Route availableOffline exact path="/snap-a-photo" component={SnapPhoto} />

        <Route clinicalPhotoRequired availableOffline exact path="/patient" component={Patient} />
        <Route clinicalPhotoRequired availableOffline exact path="/bodylocator" component={BodyLocator} />
        <Route clinicalPhotoRequired availableOffline exact path="/qa" component={QA} />
        <Route clinicalPhotoRequired exact path="/create-account" component={CreateAccount} />
        <Route clinicalPhotoRequired availableOffline signinRequired exact path="/results" component={Results} />
        <Route clinicalPhotoRequired availableOffline exact path="/error" component={Error} />

        <Route signinRequired exact path="/profile" component={Profile} />

        <Route availableOffline exact path="/*" component={() => <Redirect to="/" />} />
      </Switch>
    );
  }
}

AppRouter.defaultProps = {};

AppRouter.propTypes = {
  app: PropTypes.object.isRequired
};

export default withAppContext(AppRouter);
